import React, { useContext, useEffect, useState } from "react";
import "./Home.css";
import Modal from "react-modal";
import { BiCurrentLocation, BiMap } from "react-icons/bi";
import { HiOutlineX } from "react-icons/hi";
import storeIcon from "../../images/icon_store.png";
import { Link } from "react-router-dom";
import { context } from "../FrontPanel/FrontPanel";
import Login from "../Login/Login";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import axios from "axios";

const Home = () => {
  const {
    userData,
    setUserData,
    update,
    setUpdate,
    cart,
    loginModalIsOpen,
    setIsLoginOpen,
    isRegister,
    setIsRegister,
  } = useContext(context);

  const [address, setAddress] = useState();
  const [modalIsOpen, setIsOpen] = useState(false);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "5px",
      maxHeight: "449px",
    },
  };
  const locationModalHandler = () => {
    setIsOpen(true);
  };
  const logOut = () => {
    setUserData({});
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    setUpdate(!update);
  };
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });
  const [map, setmap] = useState(null);

  const containerStyle = {
    width: "400px",
    height: "200px",
  };

  const center = {
    lat: 23.804093,
    lng: 90.4152376,
  };

  const mapOptions = {
    disableDefaultUI: true, // Disable the default UI controls
    zoomControl: true, // Optionally enable zoom control
  };

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      console.log("palces", place);
      setAddress({
        formatted_address: place.formatted_address,
        geometry: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      });

      setSelectedLocation({
        lat: Number(place.geometry.location.lat()),
        lng: Number(place.geometry.location.lng()),
      });
    }
  };
  const onPlaceChangedHome = () => {
    if (autocompleteRef2nd.current) {
      const place = autocompleteRef2nd.current.getPlace();
      console.log("palces", place);
      setAddress({
        formatted_address: place.formatted_address,
        geometry: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      });
      setSelectedLocation({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    }
  };

  const autocompleteRef = React.useRef(null);
  const autocompleteRef2nd = React.useRef(null);

  const [selectedLocation, setSelectedLocation] = useState();
  useEffect(() => {
    if (selectedLocation) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: selectedLocation }, (results, status) => {
        if (status === "OK" && results[0]) {
          console.log("palces selected", results[0]);
          setAddress({
            formatted_address: results[0].formatted_address,
            geometry: {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            },
          });
        } else {
          console.error("Geocode failed:", status);
        }
      });
    }
  }, [selectedLocation]);
  const [currentLocation, setcurrentLocation] = useState();
  useEffect(() => {
    if (currentLocation) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: currentLocation }, (results, status) => {
        if (status === "OK" && results[0]) {
          console.log("palces selected", results[0]);
          setAddress({
            formatted_address: results[0].formatted_address,
            geometry: {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            },
          });
        } else {
          console.error("Geocode failed:", status);
        }
      });
    }
  }, [currentLocation]);

  const [shopMarker, setshopMarker] = useState();
  useEffect(() => {
    if (address) {
      axios
        .post("near-by-store", address.geometry)
        .then((res) => {
          console.log("Res", res.data.all);
          setshopMarker(res.data.all);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [selectedLocation, currentLocation]);

  console.log("address", address);
  return (
    <div className="h-screen home-container bg-cover bg-center">
      <div
        className={`top-section flex justify-end py-3 px-6 sm:py-4 sm:px-10 md:py-6 md:px-16 bg-white`}
      >
        {/* <h1 className='text-xl sm:text-2xl md:text-3xl font-bold text-[#134E47]'>Great Pharma</h1> */}
        {userData?.user?.name ? (
          <>
            <Link to={`/profile/${userData?.user?.id}`}>
              <h6 className="text-base sm:text-base md:text-base font-bold text-[#134E47]">
                {userData?.user?.name}
              </h6>
            </Link>
            <span className="mx-2 text-[#134E47] text-base">|</span>
            <button className="text-[#134E47] text-base" onClick={logOut}>
              Log out
            </button>
          </>
        ) : (
          <div className="login">
            {/* <Link to="/login"><button className="text-[#134E47] text-base">Login</button></Link>
                            <span className='mx-2 text-[#134E47] text-base'>|</span>
                            <Link to="/register"><button className=" text-[#134E47] text-base">Sign Up</button></Link> */}
            <button
              onClick={() => {
                setIsLoginOpen(true);
                setIsRegister(false);
              }}
              className="text-[#134E47] text-base"
            >
              Login
            </button>
            <span className="mx-2 text-[#134E47] text-base">|</span>
            <button
              onClick={() => {
                setIsLoginOpen(true);
                setIsRegister(true);
              }}
              className=" text-[#134E47] text-base"
            >
              Sign Up
            </button>
          </div>
        )}
      </div>


      <div className="flex lg:justify-end justify-center mt-[40px] sm:mt-[120px] md:mt-[80px] lg:mt-[120px] lg:mr-16">
        <h1 className="lg:text-7xl text-3xl text-white  sm:text-4xl md:text-6xl font-bold">
          Market Place
        </h1>
      </div>
      <div className="home-main-content flex lg:justify-end justify-center mt-[20px] m-4">
        <div className="home-content bg-white px-4 py-4 rounded md:flex md:w-[40%] w-[100%]">
          <div className="md:w-1/2 lg:w-[60%]">
            <label className="relative block">
              {isLoaded && (
                <Autocomplete
                  onLoad={(autocomplete) =>
                    (autocompleteRef2nd.current = autocomplete)
                  }
                  onPlaceChanged={onPlaceChangedHome}
                  types={["geocode"]}
                  componentRestrictions={{ country: "bd" }}
                >
                  <input
                    className="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300 rounded-md py-2 pl-3 pr-9 shadow-sm focus:outline-none focus:border-[#134E47] focus:ring-[#134E47] focus:ring-1 text-xs sm:text-sm"
                    placeholder={
                      address
                        ? address.formatted_address
                        : "Please enter your address"
                    }
                    type="text"
                    name="search"
                  />
                </Autocomplete>
              )}



              <span className="absolute cursor-pointer inset-y-0 right-0 flex items-center pr-2">
                <BiCurrentLocation
                  onClick={() => {
                    console.log("navigator", navigator.geolocation);

                    if (navigator.geolocation) {
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          console.log("position", position);
                          const { latitude, longitude } = position.coords;
                          setcurrentLocation({ lat: latitude, lng: longitude });
                        },
                        (error) => {
                          console.error("Error getting user location:", error);
                        }
                      );
                    } else {
                      console.error(
                        "Geolocation is not supported by this browser."
                      );
                    }
                    // setIsOpen(true)
                  }}
                />
              </span>
            </label>
          </div>
          <div className="md:w-1/2 lg:w-[40%] flex items-center mt-2 md:mt-0 justify-center md:ml-4">
            <button
              onClick={locationModalHandler}
              className="bg-[#134E47] w-[40%] text-xs sm:text-sm text-white mx-2 p-2 rounded"
            >
              Delivery
            </button>
            <span>or</span>
            <button
              onClick={locationModalHandler}
              className="bg-[#134E47] w-[40%] text-xs sm:text-sm text-white ml-2 p-2 rounded"
            >
              Pick-up
            </button>
          </div>
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="our modal"
      >
        <div className="modal-header bg-white py-2 px-2">
          <h6 className="text-lg font-bold mb-1">
            Is this your exact location ?
            <HiOutlineX
              onClick={() => setIsOpen(false)}
              className="inline float-right cursor-pointer"
            />
          </h6>
          <label className="relative block">
            {isLoaded && (
              <Autocomplete
                onLoad={(autocomplete) =>
                  (autocompleteRef.current = autocomplete)
                }
                onPlaceChanged={onPlaceChanged}
                types={["geocode"]}
                componentRestrictions={{ country: "bd" }}
              >
                <input
                  className="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300 rounded-md py-2 pl-3 pr-9 shadow-sm focus:outline-none focus:border-[#134E47] focus:ring-[#134E47] focus:ring-1 sm:text-sm"
                  type="text"
                  name="search"
                />
              </Autocomplete>
            )}

            <span
              // onClick={() => setAddress("")}
              className="absolute  inset-y-0 right-0 flex items-center cursor-pointer pr-2"
            >
              <HiOutlineX />
            </span>
          </label>
        </div>
        <div className="modal-map-container">
          {isLoaded ? (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={address ? address.geometry : center}
              zoom={14}
              options={mapOptions}
              onClick={(e) => {
                setSelectedLocation({
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                });
              }}
            >
              {selectedLocation && <Marker position={selectedLocation} />}
              {/* {selectedLocation && (
                  <Marker position={selectedLocation} icon={{
                    url: storeIcon,
                    scaledSize: new window.google.maps.Size(40, 40), // Adjust size as needed
                  }} />
                )} */}

              {shopMarker?.map((item, i) => (
                <Marker
                  key={i}
                  position={{ lat: Number(item.lat), lng: Number(item.lng) }}
                  icon={{
                    url: storeIcon,
                    scaledSize: new window.google.maps.Size(30, 30), // Adjust size as needed
                  }}
                />
              ))}
            </GoogleMap>
          ) : (
            " Loading..."
          )}

          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.7553932312994!2d90.38749101445529!3d23.720427595838736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b8dea52b605b%3A0x274150be3fde4e8e!2s3%20Dhakeshwari%20Rd%2C%20Dhaka%201211!5e0!3m2!1sen!2sbd!4v1664704269431!5m2!1sen!2sbd"
            className="w-[300px] h-[200px] md:w-[350px] md:h-[250px]"
            allowfullscreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe> */}
        </div>
        <div className="modal-bottom-section py-3 px-2">
          <p style={{ width: "385px" }}>
            <BiMap className="inline text-[#134E47]" />{" "}
            {address?.formatted_address}
          </p>
          <Link to={`${`/pharmacy-list/${address?.formatted_address}`}`}>
            <button
              onClick={() => {
                {
                  address &&
                    localStorage.setItem("address", JSON.stringify(address));
                }
              }}
              className="w-full bg-[#134E47] text-white py-1 rounded mt-1"
            >
              Confirm
            </button>
          </Link>
        </div>
      </Modal>
      <Login />
    </div>
  );
};

export default Home;
